import { Toaster } from "@/components/ui/sonner";
import AnnouncementBar from "@/components/landing/AnnouncementBar";
import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";
import WhatsAppFAB from "@/components/landing/WhatsAppFAB";
import LeadFormFAB from "@/components/landing/LeadFormFAB";
import VideoMarquee from "@/components/testimonials/VideoMarquee";
import { Play, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function Testimonials() {
  return (
    <div data-testid="testimonials-page" className="relative bg-white">
      <AnnouncementBar />
      <Navbar />

      <main className="pt-40 pb-24 sm:pt-44">
        {/* Hero */}
        <section
          data-testid="testimonials-hero"
          className="relative max-w-7xl mx-auto px-6 lg:px-8"
        >
          <div className="max-w-4xl">
            <Link
              to="/"
              data-testid="back-to-home"
              className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.3em] font-semibold text-[#2770FD] hover:text-black transition-colors mb-6"
            >
              ← Back to Home
            </Link>
            <span className="block text-xs uppercase tracking-[0.3em] font-semibold text-[#2770FD] mb-5">
              Client Success Hub
            </span>
            <h1
              data-testid="testimonials-heading"
              className="font-display text-black text-5xl sm:text-6xl lg:text-7xl leading-[0.95]"
            >
              Receipts <span className="text-accent-blue">in Motion.</span>
            </h1>
            <p className="mt-6 text-black/70 text-base sm:text-lg font-light leading-relaxed max-w-2xl">
              Hear it directly from the founders, CFOs, and brand teams who put
              their growth on us. Real voices, real campaigns, real numbers —
              looping seamlessly across the canvas below.
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-4">
              <a
                href="mailto:Connect@dynamicxmedia.com?subject=Project%20Brief"
                data-testid="testimonials-cta"
                className="inline-flex items-center gap-2 rounded-full bg-cta-solid text-white text-sm font-semibold px-6 py-3 glow-cta-light transition-all duration-300 hover:-translate-y-0.5"
              >
                <Play className="h-4 w-4" fill="white" />
                Become our next case study
                <ArrowRight className="h-4 w-4" />
              </a>
              <span className="text-xs uppercase tracking-[0.3em] text-black/55">
                12 brands · 4 industries · 1 operating system
              </span>
            </div>
          </div>
        </section>

        {/* Continuous video marquee */}
        <section className="relative mt-16 sm:mt-20">
          <VideoMarquee />
        </section>

        {/* Trust footer band */}
        <section className="max-w-7xl mx-auto px-6 lg:px-8 mt-20 sm:mt-24">
          <div className="rounded-2xl border border-black/10 bg-white p-8 sm:p-12 text-center soft-blue-glow">
            <p className="font-display text-black text-2xl sm:text-3xl leading-tight max-w-2xl mx-auto">
              Your story belongs on this loop.{" "}
              <span className="text-accent-blue">Let&apos;s engineer it.</span>
            </p>
            <a
              href="mailto:Connect@dynamicxmedia.com?subject=Strategy%20Call"
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-cta-solid text-white text-sm font-semibold px-6 py-3 glow-cta-light transition-all duration-300 hover:-translate-y-0.5"
            >
              Book a strategy call
              <ArrowRight className="h-4 w-4" />
            </a>
          </div>
        </section>
      </main>

      <Footer />
      <LeadFormFAB />
      <WhatsAppFAB />
      <Toaster position="bottom-center" richColors />
    </div>
  );
}
